import React, {Component} from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {withQuery, withMutation} from '../../../../shared/enhancers/graphql-enhancer.js';
import {stackup} from '../../../../data/stackups/queries.js';
import AlternateDecisions from '../../../../shared/library/cards/alternate-decision';
import {CATHEDRAL} from '../../../../shared/style/colors.js';
import {compose} from 'react-apollo';
import {trackViews} from '../../../../data/shared/mutations.js';
import {callTrackViews} from '../../../../../app/shared/utils/trackViews.js';

const Container = glamorous.div({
  margin: '20px auto'
});
const Heading = glamorous.div({
  color: CATHEDRAL,
  textTransform: 'uppercase',
  fontWeight: 'bold',
  fontSize: 13
});

class StackupDecisionsContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    decisions: PropTypes.object,
    trackViews: PropTypes.func
  };

  componentDidMount() {
    const {loading, decisions, trackViews} = this.props;
    if (!loading && decisions.stackDecisions.length !== 0) {
      const decisionIds = decisions.stackDecisions.map(d => d.id);
      callTrackViews({
        trackViews,
        decisionIds,
        clientContext: `StackupDecisionsContainer-${window.location.pathname}`
      });
    }
  }

  render() {
    const {loading, decisions} = this.props;
    return (
      <Container>
        {!loading && decisions.stackDecisions.length !== 0 && (
          <Heading>Related Stack Decisions</Heading>
        )}
        {!loading && decisions.stackDecisions.length !== 0 && (
          <AlternateDecisions decisions={decisions.stackDecisions} />
        )}
      </Container>
    );
  }
}

export class StackupDecisions extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    decisions: PropTypes.object,
    trackViews: PropTypes.func
  };

  render() {
    const {loading, decisions, trackViews} = this.props;
    return decisions ? (
      <StackupDecisionsContainer loading={loading} decisions={decisions} trackViews={trackViews} />
    ) : (
      <></>
    );
  }
}

export default compose(
  withQuery(stackup, data => ({
    decisions: data.stackup,
    loading: data.loading
  })),
  withMutation(trackViews, mutate => ({
    trackViews: (decisionIds, clientContext) => mutate({variables: {decisionIds, clientContext}})
  }))
)(StackupDecisions);
